import React from 'react';
import { AnnouncementBar } from './components/AnnouncementBar';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { PainPoints } from './components/PainPoints';
import { BenefitsSection } from './components/BenefitsSection';
import { WhatIsIncluded } from './components/WhatIsIncluded';
import { BonusSection } from './components/BonusSection';
import { HowItWorks } from './components/HowItWorks';
import { WhoItsFor } from './components/WhoItsFor';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { SocialProofToast } from './components/SocialProofToast';
export function App() {
  return <div className="min-h-screen bg-cream font-sans text-dark selection:bg-primary/30 selection:text-dark" data-id="element-0">
      <AnnouncementBar data-id="element-1" />
      <Navbar data-id="element-2" />

      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <PainPoints data-id="element-5" />
        <BenefitsSection data-id="element-6" />
        <WhatIsIncluded data-id="element-7" />
        <BonusSection data-id="element-8" />
        <HowItWorks data-id="element-9" />
        <WhoItsFor data-id="element-10" />
        <Testimonials data-id="element-11" />
        <FAQ data-id="element-12" />
        <FinalCTA data-id="element-13" />
      </main>

      <Footer data-id="element-14" />
      <SocialProofToast data-id="element-15" />
    </div>;
}